<template>
  <v-main>

    <v-container class="fill-height" fluid>
    <Register />
    </v-container>
  </v-main>
</template>

<script>
import Register from "./Register.vue";
export default {
  name: "index.vue",
  components: {
    Register,
  },
  data() {
    return {};
  },
}
</script>

<style scoped>

</style>